import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import dayjs from 'dayjs';
import { message } from 'ant-design-vue';
import { awaitWrap, handleExportFile, reportEvent } from '@/common';
import { exportWechatComplaintList, queryComplaintMerchantOptions, queryComplaintProblemDescriptionOptions, queryComplaintProductOptions, queryQuickReplyTemplates, queryWechatComplaintDetail, queryWechatComplaintList, queryWechatComplaintNegotiationPage, queryWechatComplaintStatistics } from '@/api/wechatComplaint';
import { isOkResponse, useComplaintActions } from './useComplaintActions';
const defaultComplaintTimeRange = () => [dayjs().subtract(29, 'day').startOf('day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')];
export const createComplaintFilter = () => ({
  complaintTime: defaultComplaintTimeRange(),
  orderKeyword: '',
  problemCodes: [],
  complaintStates: [],
  refundStates: [],
  complainedMerchantIds: [],
  complainedProductIds: []
});
const CHNL_FLAG = 'weixin';
const toNumber = value => {
  const matched = String(value !== null && value !== void 0 ? value : '').match(/-?\d+(\.\d+)?/);
  return matched ? Number(matched[0]) : 0;
};
const normalizeReshipStatus = value => {
  const status = value == null ? '' : String(value);
  return status || undefined;
};
const normalizeComplaint = item => {
  var _item$complaintMainId, _item$amount, _item$complaintOrderA, _item$complainedMerch, _item$complainedProdu, _item$lastOperator, _item$pendingAssignee;
  return {
    ...item,
    complaintMainId: (_item$complaintMainId = item === null || item === void 0 ? void 0 : item.complaintMainId) !== null && _item$complaintMainId !== void 0 ? _item$complaintMainId : item === null || item === void 0 ? void 0 : item.id,
    reshipStatus: normalizeReshipStatus(item === null || item === void 0 ? void 0 : item.reshipStatus),
    amount: (_item$amount = item === null || item === void 0 ? void 0 : item.amount) !== null && _item$amount !== void 0 ? _item$amount : toNumber((item === null || item === void 0 ? void 0 : item.complaintOrderAmount) || (item === null || item === void 0 ? void 0 : item.applyRefundAmount)),
    complaintOrderAmount: (_item$complaintOrderA = item === null || item === void 0 ? void 0 : item.complaintOrderAmount) !== null && _item$complaintOrderA !== void 0 ? _item$complaintOrderA : null,
    merchantName: (_item$complainedMerch = item === null || item === void 0 ? void 0 : item.complainedMerchantLabel) !== null && _item$complainedMerch !== void 0 ? _item$complainedMerch : item === null || item === void 0 ? void 0 : item.merchantName,
    productName: (_item$complainedProdu = item === null || item === void 0 ? void 0 : item.complainedProductLabel) !== null && _item$complainedProdu !== void 0 ? _item$complainedProdu : item === null || item === void 0 ? void 0 : item.productName,
    operatorName: (_item$lastOperator = item === null || item === void 0 ? void 0 : item.lastOperator) !== null && _item$lastOperator !== void 0 ? _item$lastOperator : item === null || item === void 0 ? void 0 : item.operatorName,
    pendingHandler: (_item$pendingAssignee = item === null || item === void 0 ? void 0 : item.pendingAssigneeNames) !== null && _item$pendingAssignee !== void 0 ? _item$pendingAssignee : item === null || item === void 0 ? void 0 : item.pendingHandler
  };
};
const normalizeHistory = item => {
  var _item$complaintMediaL;
  return {
    ...item,
    imageList: (item === null || item === void 0 || (_item$complaintMediaL = item.complaintMediaList) === null || _item$complaintMediaL === void 0 ? void 0 : _item$complaintMediaL.mediaUrl) || []
  };
};
const buildWarnings = detail => {
  const banners = (detail === null || detail === void 0 ? void 0 : detail.banners) || {};
  return [banners.showInternalReject ? {
    type: 'refundRejected',
    title: '内部退款审批被驳回',
    reason: '该订单的退款申请已被内部审核驳回，（驳回原因：',
    strongReason: banners.internalRejectMessage || '-',
    reasonSuffix: '）。请核实后修改信息，再次尝试发起退款流程。'
  } : null, banners.showWechatRefundFail ? {
    type: 'refundFailed',
    title: '历史微信退款失败',
    reason: '该订单曾发起退款但执行失败（失败原因：',
    strongReason: banners.wechatRefundFailMessage || '-',
    reasonSuffix: '）。您可以重新核实情况并确保商户号状态正常后，再次尝试发起退款流程。'
  } : null].filter(Boolean);
};
export const useWechatComplaint = () => {
  const filterForm = reactive(createComplaintFilter());
  const loading = ref(false);
  const dataSource = ref([]);
  const total = ref(0);
  const pageNum = ref(1);
  const pageSize = ref(20);
  const selectedRowKeys = ref([]);
  const selectedRows = ref([]);
  const currentComplaint = ref(null);
  const detailLoading = ref(false);
  const merchantOptions = ref([]);
  const problemOptions = ref([]);
  const productOptions = ref([]);
  const replyTemplates = ref([]);
  const hasRequestedList = ref(false);
  const hasRequestedProductOptions = ref(false);
  const overview = reactive({
    pendingCount: '-',
    processingCount: '-',
    todayFinishedCount: '-',
    refundApprovingCount: '-'
  });
  const overviewList = computed(() => [{
    key: 'pending',
    label: '待处理客诉',
    value: overview.pendingCount,
    desc: '请优先响应并跟进',
    type: 'warning'
  }, {
    key: 'processing',
    label: '处理中客诉',
    value: overview.processingCount,
    desc: '正在跟进中',
    type: 'info'
  }, {
    key: 'finished',
    label: '今日已处理',
    value: overview.todayFinishedCount,
    desc: '客诉已妥善结单',
    type: 'success'
  }, {
    key: 'approval',
    label: '退款审批中',
    value: overview.refundApprovingCount,
    desc: '等待财务复核',
    type: 'danger'
  }]);
  const buildFilterParams = () => {
    var _filterForm$complaint, _filterForm$complaint2;
    return {
      chnlFlag: CHNL_FLAG,
      startDate: (_filterForm$complaint = filterForm.complaintTime) !== null && _filterForm$complaint !== void 0 && _filterForm$complaint[0] ? dayjs(filterForm.complaintTime[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss') : undefined,
      endDate: (_filterForm$complaint2 = filterForm.complaintTime) !== null && _filterForm$complaint2 !== void 0 && _filterForm$complaint2[1] ? dayjs(filterForm.complaintTime[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss') : undefined,
      orderKeyword: filterForm.orderKeyword,
      problemDescriptions: filterForm.problemCodes,
      complaintStates: filterForm.complaintStates,
      refundStates: filterForm.refundStates,
      complainedMerchantIds: filterForm.complainedMerchantIds,
      complainedProductIds: filterForm.complainedProductIds
    };
  };
  const buildParams = () => ({
    pageNum: pageNum.value,
    pageSize: pageSize.value,
    ...buildFilterParams()
  });
  const getFilterOptions = async () => {
    const params = {
      chnlFlag: 'weixin'
    };
    const [[, merchantRes], [, problemRes]] = await Promise.all([awaitWrap(queryComplaintMerchantOptions(params)), awaitWrap(queryComplaintProblemDescriptionOptions(params))]);
    if (isOkResponse(merchantRes)) {
      merchantOptions.value = (merchantRes.data || []).map(item => ({
        label: item.label,
        value: item.id
      }));
    }
    if (isOkResponse(problemRes)) {
      problemOptions.value = (problemRes.data || []).map(item => {
        var _item$label, _item$id;
        return {
          label: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : item,
          value: (_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : item
        };
      });
    }
  };
  const getProductOptions = async () => {
    if (hasRequestedProductOptions.value) return;
    hasRequestedProductOptions.value = true;
    const [, productRes] = await awaitWrap(queryComplaintProductOptions({
      chnlFlag: CHNL_FLAG
    }));
    if (isOkResponse(productRes)) {
      productOptions.value = (productRes.data || []).map(item => ({
        label: item.label,
        value: item.id
      }));
    }
  };
  const getQuickReplyTemplates = async () => {
    const [, res] = await awaitWrap(queryQuickReplyTemplates());
    if (isOkResponse(res)) replyTemplates.value = (res.data || []).map(item => ({
      title: item.id,
      content: item.text
    })).filter(item => item.content);
  };
  const getStatistics = async () => {
    const [, res] = await awaitWrap(queryWechatComplaintStatistics({
      statDate: dayjs().format('YYYY-MM-DD'),
      chnlFlag: CHNL_FLAG
    }));
    if (isOkResponse(res)) {
      var _data$todayProcessedC;
      const data = res.data || {};
      Object.assign(overview, {
        ...data,
        todayFinishedCount: (_data$todayProcessedC = data.todayProcessedCount) !== null && _data$todayProcessedC !== void 0 ? _data$todayProcessedC : data.todayFinishedCount
      });
      return;
    }
    Object.assign(overview, {
      pendingCount: '-',
      processingCount: '-',
      todayFinishedCount: '-',
      refundApprovingCount: '-'
    });
  };
  const getList = async (force = false) => {
    if (hasRequestedList.value && !force) return;
    hasRequestedList.value = true;
    loading.value = true;
    const startTime = Date.now();
    const [err, res] = await awaitWrap(queryWechatComplaintList(buildParams()));
    loading.value = false;
    const reportSearch = status => reportEvent({
      eventName: '_search',
      properties: {
        ui_name: '微信客诉',
        return_duration: (Date.now() - startTime) / 1000,
        query_status: status
      }
    });
    if (err) {
      dataSource.value = [];
      total.value = 0;
      reportSearch('failed');
      return;
    }
    if (isOkResponse(res)) {
      var _res$count, _ref, _ref2, _data$total;
      const data = (res === null || res === void 0 ? void 0 : res.data) || {};
      const list = Array.isArray(data) ? data : data.list || data.records || [];
      dataSource.value = list.map(normalizeComplaint);
      total.value = Array.isArray(data) ? (_res$count = res === null || res === void 0 ? void 0 : res.count) !== null && _res$count !== void 0 ? _res$count : list.length : (_ref = (_ref2 = (_data$total = data.total) !== null && _data$total !== void 0 ? _data$total : data.count) !== null && _ref2 !== void 0 ? _ref2 : res === null || res === void 0 ? void 0 : res.count) !== null && _ref !== void 0 ? _ref : 0;
      reportSearch('succeed');
      return;
    }
    dataSource.value = [];
    total.value = 0;
    reportSearch('failed');
  };
  const search = async () => {
    pageNum.value = 1;
    selectedRowKeys.value = [];
    selectedRows.value = [];
    await getStatistics();
    await getList(true);
  };
  const reset = () => {
    Object.assign(filterForm, createComplaintFilter());
    search();
  };
  // 跨页勾选：ant-design 回调的 rows 只含当前页记录，需手动合并保留上一页已选项
  const selectRows = (keys, rows) => {
    const keySet = new Set(keys);
    const rowMap = new Map(selectedRows.value.filter(row => keySet.has(row.complaintMainId)).map(row => [row.complaintMainId, row]));
    rows.forEach(row => {
      if (keySet.has(row.complaintMainId)) rowMap.set(row.complaintMainId, row);
    });
    selectedRowKeys.value = keys;
    selectedRows.value = keys.map(key => rowMap.get(key)).filter(row => !!row);
  };
  const openDetail = async record => {
    currentComplaint.value = record;
    detailLoading.value = true;
    try {
      const complaintMainId = record.complaintMainId;
      const [detailResult, historyResult] = await Promise.all([awaitWrap(queryWechatComplaintDetail({
        complaintMainId
      })), awaitWrap(queryWechatComplaintNegotiationPage({
        complaintMainId,
        offset: 0,
        limit: 300
      }))]);
      const [, res] = detailResult;
      const [, historyRes] = historyResult;
      if (isOkResponse(res)) {
        var _ref3, _order$amount, _ref4, _order$linkedOrderNo, _ref5, _order$shipStatus, _ref6, _order$reshipStatus;
        const data = res.data || {};
        const complain = normalizeComplaint(data.complain || {});
        const order = data.order || {};
        const refund = data.refund || {};
        currentComplaint.value = {
          ...record,
          ...complain,
          amount: (_ref3 = (_order$amount = order.amount) !== null && _order$amount !== void 0 ? _order$amount : complain.amount) !== null && _ref3 !== void 0 ? _ref3 : record.amount,
          outTradeNo: (_ref4 = (_order$linkedOrderNo = order.linkedOrderNo) !== null && _order$linkedOrderNo !== void 0 ? _order$linkedOrderNo : complain.linkedOrderNo) !== null && _ref4 !== void 0 ? _ref4 : record.linkedOrderNo,
          storeName: order.storeName,
          productDisplayName: order.productDisplayName,
          goodsName: order.skuName || order.prodName || order.productDisplayName,
          payStatus: order.payStatusLabel,
          payTime: order.payTime,
          shipStatus: (_ref5 = (_order$shipStatus = order.shipStatus) !== null && _order$shipStatus !== void 0 ? _order$shipStatus : complain.shipStatus) !== null && _ref5 !== void 0 ? _ref5 : record.shipStatus,
          shipTime: order.shipTime,
          reshipStatus: normalizeReshipStatus((_ref6 = (_order$reshipStatus = order.reshipStatus) !== null && _order$reshipStatus !== void 0 ? _order$reshipStatus : complain.reshipStatus) !== null && _ref6 !== void 0 ? _ref6 : record.reshipStatus),
          deviceId: order.deviceId,
          warnings: buildWarnings(data),
          actions: data.actions,
          refundState: complain.refundState || refund.refundStatus || record.refundState
        };
      }
      if (isOkResponse(historyRes) && currentComplaint.value) {
        var _historyRes$data;
        currentComplaint.value.history = (((_historyRes$data = historyRes.data) === null || _historyRes$data === void 0 ? void 0 : _historyRes$data.list) || []).map(normalizeHistory);
      }
    } finally {
      detailLoading.value = false;
    }
  };
  const refreshDetail = async () => {
    if (currentComplaint.value) await openDetail(currentComplaint.value);
  };
  const clearDetail = () => {
    currentComplaint.value = null;
  };
  const exportList = async () => {
    var _filterForm$complaint3, _filterForm$complaint4;
    if (!total.value) return message.warning('暂无数据');
    const [err, res] = await awaitWrap(exportWechatComplaintList(buildFilterParams()));
    if (err) return message.error('导出失败，请稍后重试');
    const start = (_filterForm$complaint3 = filterForm.complaintTime) !== null && _filterForm$complaint3 !== void 0 && _filterForm$complaint3[0] ? dayjs(filterForm.complaintTime[0]).format('YY_MM_DD') : dayjs().format('YY_MM_DD');
    const end = (_filterForm$complaint4 = filterForm.complaintTime) !== null && _filterForm$complaint4 !== void 0 && _filterForm$complaint4[1] ? dayjs(filterForm.complaintTime[1]).format('YY_MM_DD') : dayjs().format('YY_MM_DD');
    handleExportFile(res, `投诉单_${start}-${end}`, 'csv');
  };
  const actions = useComplaintActions({
    currentComplaint,
    selectedRows,
    selectedRowKeys,
    refresh: () => getList(true),
    refreshDetail
  });
  return {
    filterForm,
    loading,
    submitLoading: actions.submitLoading,
    dataSource,
    total,
    pageNum,
    pageSize,
    selectedRows,
    selectedRowKeys,
    currentComplaint,
    detailLoading,
    merchantOptions,
    problemOptions,
    productOptions,
    replyTemplates,
    overviewList,
    getList,
    getFilterOptions,
    getStatistics,
    getProductOptions,
    getQuickReplyTemplates,
    search,
    reset,
    selectRows,
    openDetail,
    clearDetail,
    exportList,
    reply: actions.reply,
    resend: actions.resend,
    refund: actions.refund,
    rejectRefund: actions.rejectRefund,
    batchSubmit: actions.batchSubmit
  };
};